import { ListLayout } from '@ingrid/luterkort-react';

import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

export function SchemaDisplayNumber({ schema }: Props) {
  if (schema.type !== 'number') {
    return null;
  }

  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{schema.title}</ListLayout.SecondaryText>
      <ListLayout.PrimaryText>{schema.value ?? '-'}</ListLayout.PrimaryText>
    </ListLayout.Stack>
  );
}
